import styled from "styled-components";
import { COLORS } from "../../../../../layout/theme";

export const Inner = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	border: ${(props) =>
		props.danger
			? `1px solid ${COLORS.Danger}`
			: `1px solid ${COLORS.LightGrey3}`};
	border-radius: 12px;
	padding: 14px 30px;
	background: ${(props) => (props.danger ? "#fff1f0" : "#ffffff")};
`;
